var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('grid',{ref:"ApprovalHistoryGrid",attrs:{"name":"","desc":"","checkboxes":false,"views":false,"layout":"frame","search":"","endpoint":_vm.api.$.approval.getApprovalRulesHistory}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1bf40d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Approvals/Approval-history/index.vue
// module id = JFv1
// module chunks = 12